import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function CodeBlock({ lang, code, compact = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      toast.success("Copiat în clipboard");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copierea nu a reușit");
    }
  };

  return (
    <div className={`bg-surface border border-line/10 overflow-hidden group/code ${compact ? "text-xs" : ""}`}>
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-line/10 bg-bg">
        <span className="label-tiny">{lang || "text"}</span>
        <button
          data-testid="copy-code-button"
          onClick={copy}
          className="text-xs flex items-center gap-1 text-fg/40 hover:text-fg transition-colors"
        >
          {copied ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
          {copied ? "copied" : "copy"}
        </button>
      </div>
      <pre className="p-3 overflow-x-auto text-[13px] leading-relaxed mono text-fg/90">
        <code>{code}</code>
      </pre>
    </div>
  );
}
